import { FileUploadService } from '../../api/services/file-upload.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileUploadType } from '../../api/models/file-uploaded';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent {

  @Input() uploadBtnText = 'Upload';
  @Input() showDescription = false;
  @Input() accept : String=''; // accept all files
  @Input() fileType: string;
  @Input() fileUploadType = FileUploadType;
  @Input() bulkProjectUploadFlow: boolean = false;

  @Output() biggerFile: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() uploaded: EventEmitter<string> = new EventEmitter<string>();
  @Output() inprogress: EventEmitter<boolean> = new EventEmitter<boolean>();

  fileToUpload: File = null;

  fileSizeExceeded = false;

  description = '';
  errorMessage: string="";
  // errorMessage: string[] = [];

  labelText = 'No file chosen';
  labelTextBackup: string;

  uploading = false;
  progress: number;

  constructor(private fileUploadService: FileUploadService) {}

  handleFileInput(files: FileList) {
    let clearFieldValues = false;
    this.errorMessage = '';
    const file = files.item(0);
    if (file === null || (this.accept && !this.accept.includes(file.name.split('.').pop()))) 
    { return; }

    if(file != null){
      if(this.fileType === this.fileUploadType.CSV && !file.name.endsWith(".csv")) {
        this.errorMessage = "Please upload CSV file.";
        clearFieldValues = true;
        return;
      }

      if(this.fileType === this.fileUploadType.XLSX && !file.name.endsWith(".xlsx")) {
        this.errorMessage = "Please upload XLSX file.";
        clearFieldValues = true;
        return;
      }

      if (this.bulkProjectUploadFlow) {
        let fileSize = this.humanReadableFileSize(file.size);
        if (fileSize.endsWith('GB') || fileSize.endsWith('TB')) {
          this.errorMessage = "File size is more.";
          clearFieldValues = true;
        } else if (fileSize.endsWith('MB')) {
          let size = fileSize.split(" ")[0];
          if (Number(size) > 5) {
            console.log('Size is greater than 5 MB, hence invoking async call.. ')
            this.biggerFile.emit(true);
          }
        } else {
          let reader = new FileReader();
          reader.readAsBinaryString(file);
          reader.onload = (e: any) => {
            /* create workbook */
            const binarystr: string = e.target.result;
            const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

            /* selected the first sheet */
            const wsname: string = wb.SheetNames[0];
            const ws: XLSX.WorkSheet = wb.Sheets[wsname];

            /* save data */
            const data = XLSX.utils.sheet_to_json(ws, { header : 1 });
            console.log(data.length)
            if (data && data.length > 10) {
              console.log('Data is more than 10, hence invoking async call.. ')
              this.biggerFile.emit(true);
            } else {
              console.log('invoking sync call.. ')
              this.biggerFile.emit(false);
            }
          };

          reader.onerror =  () => {
            this.errorMessage = "Error is occured while reading file!";
            clearFieldValues = true;
          };
        }
      }  
    }
    
    this.fileSizeExceeded = false;
    this.fileToUpload = file;
    this.labelTextBackup = this.labelText;
    this.labelText = this.fileToUpload.name;

    if(clearFieldValues){
      this.fileToUpload = this.description = null;
    }
  }

  onDescriptionChange(description: string) {
    this.description = description;
  }

  upload() {
    this.labelText = this.labelTextBackup;
    this.inprogress.emit(true);
    this.fileUploadService.upload(this.fileToUpload, this.description)
    .do(res => this.uploading = res.progress >= 1 && res.progress <= 100)
    .do(res => this.progress = res.progress)
    .filter(res => !!res.id)
    .subscribe(res => {
      this.uploading = false;
      this.uploaded.emit(res.id);
    });
    this.fileToUpload = this.description = null;
  }

  private humanReadableFileSize(size: number) {
    const i = Math.floor( Math.log(size) / Math.log(1024) );
    return `${(size / Math.pow(1024, i) ).toFixed(2)} ${['B', 'kB', 'MB', 'GB', 'TB'][i]}`;
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/file-upload/file-upload.component.ts